import { useContext, useEffect } from 'react';
import NRSBOMDrawer from './NRSBOMDrawer';
import { DEPENDENCIES } from '../../../graphql/queries/dependency';
import { useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { FiltersContext } from '../../NRReportTabs/NRReportFilterContextWrapper';
import { parseData } from '../NRSBOMTableContainer';
import useNRPaginatedQuery from '../../../graphql/useNRPaginatedQuery';
import { FEATURE_FLAGS } from '../../../constants/constants';
import { useFlag } from '@openfeature/react-sdk';

function NRSBOMDrawerContainer({ searchParams }) {
  const { setDrawerContent, drawerContent } = useContext(FiltersContext);
  const { componentId } = useParams();
  const { value: isComponentIdentifiedViaEnabled } = useFlag(FEATURE_FLAGS.COMPONENT_IDENTIFIED_VIA, false);
  const { value: isComponentConfidenceEnabled } = useFlag(FEATURE_FLAGS.COMPONENT_CONFIDENCE, false);
  const { value: isAiRelatedDependenciesEnabled } = useFlag(FEATURE_FLAGS.AI_RELATED_DEPENDENCIES, false);
  const { value: isAiModelAttributesEnabled } = useFlag(FEATURE_FLAGS.AI_MODEL_ATTRIBUTES, false);

  const [dependency, isDependencyLoading] = useNRPaginatedQuery({
    query: DEPENDENCIES,
    options: {
      variables: {
        includeIdentifiedVia: isComponentIdentifiedViaEnabled,
        includeConfidence: isComponentConfidenceEnabled,
        includeAiRelatedDependencies: isAiRelatedDependenciesEnabled,
        includeAiModelAttributes: isAiModelAttributesEnabled,
        args: {
          cursor: { first: 10 },
          filter: {
            fields: [
              !!searchParams.name
                ? {
                    fieldName: 'NAME',
                    value: searchParams.name,
                    operation: 'EQUAL'
                  }
                : null,
              !!searchParams.version
                ? {
                    fieldName: 'VERSION',
                    value: searchParams.version,
                    operation: 'EQUAL'
                  }
                : null,
              searchParams.vendor
                ? {
                    fieldName: 'VENDOR',
                    value: searchParams.vendor,
                    operation: 'EQUAL'
                  }
                : null
            ].filter(Boolean)
          },
          composedAssetId: componentId
        }
      },
      context: { version: 'v3' },
      fetchPolicy: 'no-cache'
    },
    qlObjKey: 'dependencies',
    transformData: data => parseData(data, () => {}, false)
  });

  useEffect(() => {
    if (!!dependency) {
      drawerContent.pop(); // take out this container from the list
      setDrawerContent([...drawerContent, <NRSBOMDrawer row={dependency[0]} />]);
    }
  }, [dependency]);

  return (
    <Box display={'flex'} width={'100%'} height={'100%'} alignItems={'center'} justifyContent={'center'}>
      <CircularProgress color={'primary'} />
    </Box>
  );
}
export default NRSBOMDrawerContainer;
